<div class="shift-compliance-container">
	<h1 class="shift-compliance-header">Board of Directors</h1>
</div>

<!-- Board of Director Cards -->
<div class="module-cards-container text-center">
	<div class="row module-cards-grid">
		<div class="col-lg-6 mb-5">
			<div class="regscale-works-card-bottom">
				<img
					width="120px"
					height="120px"
					src="../../assets/img/team/anil.svg"
					alt=""
				/>
			</div>
			<div class="regscale-works-card-outer px-3 pt-2 pb-3">
				<div
					class="regscale-works-card-inner module-cards-linear-gradient3"
				>
					<div
						class="regscale-works-content px-3 px-xl-4 text-center"
					>
						<div>
							<strong
								class="regscale-works-card module-cards-linear-gradient3"
								>Anil Karmel
							</strong>
							<p class="mt-2">Board of Directors</p>
							<p class="mt-4">
								Anil Karmel serves as the co-founder and CEO of
								RegScale designed to bring the principles of
								DevOps to Compliance (Regulatory Operations:
								RegOps). Formerly, Anil served as the National
								Nuclear Security Administration's (NNSA) Deputy
								Chief Technology Officer. Karmel began his
								government career as a Technical Staff Member of
								Los Alamos National Laboratory (LANL) and was
								responsible for inventing their cloud and
								collaboration technologies
								<span
									*ngIf="!showMore1"
									(click)="toggleMore1()"
									class="moreBtn1"
									>...more
								</span>

								<span *ngIf="showMore1" id="more1"
									>Karmel and his team have garnered industry
									and government accolades, including the SANS
									National Cyber Security Innovators Award for
									Cloud Security, InformationWeek 500 Top
									Government IT Innovators, ACT/IAC
									Excellence.gov Award and the DOE Secretary's
									Achievement Award. Anil currently serves as
									the president of the Cloud Security
									Alliance’s DC Metro Area Chapter and as a
									member of the CSA's CxO Trust Advisory
									Council.
									<span
										*ngIf="showMore1"
										class="moreBtn3"
										(click)="showLess1()"
										>...less</span
									>
								</span>
							</p>
						</div>
						<a
							target="_blank"
							href="https://www.linkedin.com/in/anilkarmel/"
						>
							<img
								class="mt-4"
								src="../../assets/img/linkedin-blue.svg"
								alt=""
							/>
						</a>
					</div>
				</div>
			</div>
		</div>

		<div class="col-lg-6 mb-5">
			<div class="regscale-works-card-bottom">
				<img
					width="120px"
					height="120px"
					src="../../assets/img/team/travis.svg"
					alt=""
				/>
			</div>
			<div class="regscale-works-card-outer px-3 pt-2 pb-3">
				<div
					class="regscale-works-card-inner module-cards-linear-gradient2"
				>
					<div
						class="regscale-works-content px-3 px-xl-4 text-center"
					>
						<div>
							<strong
								class="regscale-works-card module-cards-linear-gradient2"
								>Travis Howerton
							</strong>
							<p class="mt-2">Board of Directors</p>
							<p class="mt-4">
								After executive leadership roles in some of the
								largest public and private sector IT
								organizations in the United States (to include
								the National Nuclear Security Administration
								(NNSA), Oak Ridge National Laboratory (ORNL),
								and Bechtel), Howerton joined RegScale to drive
								product development and corporate strategy. With
								over 20 years delivering "no fail" missions, he
								is a trusted advisor of our largest clients,
								thought leader for our product strategy, and
								focused on delivering
								<span
									*ngIf="!showMore2"
									class="moreBtn2"
									(click)="toggleMore2()"
									>...more</span
								>
								<span *ngIf="showMore2" id="more2">
									sustainable long-term growth for the
									company. Travis is a serial innovator having
									won the Fed 100 Award, the ACT-IAC Award for
									Most Innovative Project in Government,
									maintains multiple certifications including
									his PMP, ITIL, CISSP, and Harvard Credential
									of Readiness, and graduated with a Master's
									of Science in Computer Information Systems
									from Boston University.

									<span
										*ngIf="showMore2"
										class="moreBtn3"
										(click)="showLess2()"
										>...less</span
									>
								</span>
							</p>
						</div>
						<a
							href="https://www.linkedin.com/in/travishowerton/"
							target="_blank"
						>
							<img
								class="mt-4"
								src="../../assets/img/linkedin-blue.svg"
								alt=""
						/></a>
					</div>
				</div>
			</div>
		</div>

		<div class="col-lg-12 mb-5">
			<div class="regscale-works-card-bottom">
				<img
					width="120px"
					height="120px"
					src="../../assets/img/team/coviello.png"
					alt=""
				/>
			</div>
			<div class="regscale-works-card-outer px-3 pt-2 pb-3">
				<div
					class="regscale-works-card-inner module-cards-linear-gradient3"
				>
					<div
						class="regscale-works-content px-3 px-xl-4 text-center"
					>
						<div>
							<strong
								class="regscale-works-card module-cards-linear-gradient3"
								>Art Coviello
							</strong>
							<p class="mt-2">Board of Directors</p>
							<p class="mt-4">
								From 2001 until 2006, Mr. Coviello served as President and CEO of RSA. Following RSA’s acquisition by EMC Corporation (for $2.1B) in 2006 until 2015, Mr. Coviello was an Executive Vice President of EMC Corporation and head of its Security Division. Mr. Coviello has been a central figure within the information security industry for more than 25 years. Under Mr. Coviello’s leadership, he built RSA Conference into the most respected, vendor agnostic event in cybersecurity. He is frequently a featured presenter at conferences and forums around the world, and he has played key roles in several national cybersecurity initiatives. 
								<span
									*ngIf="!showMore3"
									class="moreBtn3"
									(click)="toggleMore3()"
									>...more</span
								>
								<span *ngIf="showMore3" id="more3">
									Mr. Coviello serves on the Boards of Directors of Synchrony Financial (NYSE: SYF), Tenable (NASDAQ: TENB), FireEye (NASDAQ: FEYE), Epiphany Technology Acquisition Corp. (NASDAQ: EPHY), Bugcrowd, and SecZetta (and formerly Cylance, sold to Blackberry, and Verodin, sold to FireEye). Prior to RSA, Mr. Coviello started his career as a certified public accountant at Deloitte, Haskins & Sells (Deloitte). Mr. Coviello graduated from the University of Massachusetts with a BBA, concentration in accounting.

									<span
										*ngIf="showMore3"
										class="moreBtn3"
										(click)="showLess3()"
										>...less</span
									>
								</span>
							</p>
						</div>
						<a
							target="_blank"
							href="https://www.linkedin.com/in/art-coviello-jr-366b97114/"
						>
							<img
								class="mt-4"
								src="../../assets/img/linkedin-blue.svg"
								alt=""
							/>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>


<!-- Call to Action -->
<ready-set></ready-set>
